const translations = {
    email: 'Email Address',
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number'
};

export default translations;
